export const friendlyYearRange = (yearsData: ClearableYearsArgs) => {
	const { yearFrom, yearTo, displayYearFrom, displayYearTo, yearsAreValid } =
		yearsData;

	if (!yearsAreValid) return '⚠️ Invalid years';

	// we are sweeping bad data under the rug by calling future years "present" as displayYears
	// so here, if we have two years that could both be considered "present", we say "[lowerYear] - to preset" instead of "present to present"
	if (displayYearFrom === 'present' && displayYearFrom === displayYearTo) {
		return `${yearFrom} to present`;
	}

	if (yearFrom === yearTo) {
		return `${displayYearFrom}`;
	}

	if (yearFrom) {
		return `${displayYearFrom} to ${displayYearTo}`; // 1900 to [ year || present ]
	}

	if (yearTo) {
		return `Until ${displayYearTo}`; // Until [ year || present ]
	}
};

interface ClearableYearsArgs {
	yearFrom?: string;
	yearTo?: string;
	displayYearFrom: string;
	displayYearTo: string;
	yearsAreValid: boolean;
}
